var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortBy, useTable } from "react-table";
import { useEffect, useState } from "react";
import { Box, HStack, VStack, useTheme } from "native-base";
import { useInView } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Icon from "../icons/Icon";
import useResponsive from "../util/useResponsive";
import EmptyState from "../atoms/EmptyState";
import Spinner from "../atoms/Spinner";
import Table, { Tbody, Td, Tfoot, Th, Thead, Tr } from "./Table";
const ReactTable = (_a) => {
    var _b, _c, _d;
    var { columns, data, onPress, onSortChange, onEndReached, scrollX = false, emptyState, hiddenColumns = [] } = _a, rest = __rest(_a, ["columns", "data", "onPress", "onSortChange", "onEndReached", "scrollX", "emptyState", "hiddenColumns"]);
    const { colors } = useTheme();
    const { isSmallScreen } = useResponsive();
    const [bottomRef, setBottomRef] = useState(null);
    const isFetching = useInView({
        element: bottomRef,
        onReached: onEndReached,
    });
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state: { sortBy }, } = useTable({
        columns,
        data,
        manualSortBy: !!onSortChange,
        disableMultiSort: true,
        initialState: {
            hiddenColumns,
        },
    }, useSortBy);
    const { t } = useTranslation();
    useEffect(() => {
        if (!sortBy.length || !onSortChange) {
            return;
        }
        const { id, desc } = sortBy[0];
        onSortChange(id, !desc ? "ASC" : "DESC");
    }, [onSortChange, sortBy]);
    const emptyTitle = t("measures:noData");
    const emptyMessage = ((_b = columns === null || columns === void 0 ? void 0 : columns[0]) === null || _b === void 0 ? void 0 : _b.accessor) === "firstOccurrence"
        ? t("measures:tryAgainOrSetupAnotherReminder")
        : t("noResultsAfterFilter");
    if (isSmallScreen)
        return null;
    if (data.length === 0) {
        return (_jsx(EmptyState, { title: (_c = emptyState === null || emptyState === void 0 ? void 0 : emptyState.title) !== null && _c !== void 0 ? _c : emptyTitle, message: (_d = emptyState === null || emptyState === void 0 ? void 0 : emptyState.message) !== null && _d !== void 0 ? _d : emptyMessage, my: 4 }));
    }
    return (
    // Render the UI for your table
    _jsx(Box, Object.assign({ overflowX: scrollX ? "auto" : undefined }, { children: _jsxs(Table, Object.assign({}, getTableProps(), rest, { scrollX: scrollX }, { children: [_jsx(Thead, { children: headerGroups.map((headerGroup, index) => (_createElement(Tr, Object.assign({}, headerGroup.getHeaderGroupProps(), { key: `react-table-thead-tr-${index}` }), headerGroup.headers.map((column, index) => (_createElement(Th, Object.assign({}, column.getHeaderProps(column.getSortByToggleProps), { key: `react-table-thead-tr-th-${index}`, style: {
                            width: column.width
                                ? column.width
                                : undefined,
                        } }),
                        _jsxs(HStack, { children: [_jsx(Box, Object.assign({ _text: { color: "gray.600" } }, { children: column.render("Header") })), column.defaultCanSort && (_jsxs(VStack, Object.assign({ nativeID: `sort-icons-${index}`, ml: 2 }, { children: [_jsx(Icon, { name: "chevronUp", size: 12, fill: column.isSorted &&
                                                !column.isSortedDesc
                                                ? colors
                                                    .primary[500]
                                                : colors.gray[600] }), _jsx(Icon, { name: "chevronDown", size: 12, fill: column.isSorted &&
                                                column.isSortedDesc
                                                ? colors
                                                    .primary[500]
                                                : colors.gray[600] })] })))] }))))))) }), _jsx(Tbody, Object.assign({}, getTableBodyProps(), { children: rows.map((row, rowIndex) => {
                        prepareRow(row);
                        return (_createElement(Tr, Object.assign({}, row.getRowProps(), { key: `react-table-tbody-tr-${rowIndex}`, onClick: () => {
                                onPress === null || onPress === void 0 ? void 0 : onPress(row.original);
                            }, hasOnHover: !!onPress }), row.cells.map((cell, cellIndex) => (_createElement(Td, Object.assign({}, cell.getCellProps(), { key: `react-table-tbody-tr-td-${cellIndex}`, style: {
                                width: cell.column.width
                                    ? cell.column.width
                                    : undefined,
                                minWidth: cell.column.minWidth &&
                                    cell.column.minWidth > 10
                                    ? cell.column.minWidth
                                    : undefined,
                                maxWidth: cell.column.maxWidth &&
                                    cell.column.maxWidth > 10
                                    ? cell.column.maxWidth
                                    : undefined,
                            } }),
                            _jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }, { children: cell.render("Cell") })))))));
                    }) })), onEndReached && (_jsx(Tfoot, Object.assign({ ref: setBottomRef }, { children: isFetching && _jsx(Spinner, {}) })))] })) })));
};
export default ReactTable;
